import React, { useEffect, useState, useLayoutEffect } from "react";
import "./Dashboard.scss";import { useDispatch, useSelector } from "react-redux";
import { subMonths,format, parseISO } from 'date-fns';
import i18next from "i18next";
import {getModules} from "./Redux/actions";
import { useLocation } from "react-router-dom";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  Paper,
  Container,
  alpha,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import StickyNote2OutlinedIcon from '@mui/icons-material/StickyNote2Outlined';
import SensorsOutlinedIcon from '@mui/icons-material/SensorsOutlined';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import IntegrationInstructionsOutlinedIcon from '@mui/icons-material/IntegrationInstructionsOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import PodcastsOutlinedIcon from '@mui/icons-material/PodcastsOutlined';
import { useTranslation } from "react-i18next";
import { GetData, PostData } from "../APIcalls";

// Styled components for custom styling
const GradientCard = styled(Card)(({ theme, gradientfrom, gradientto, bordercolor }) => ({
  background: `linear-gradient(135deg, ${gradientfrom} 0%, ${gradientto} 100%)`,
  border: `1px solid ${bordercolor}`,
  borderRadius: theme.spacing(1),
  transition: 'all 0.3s ease',
}));

const QuickAccessButton = styled(Button)(({ theme, gradientfrom, gradientto }) => ({
  background: `linear-gradient(135deg, ${gradientfrom} 0%, ${gradientto} 100%)`,
  borderRadius: theme.spacing(2),
  padding: theme.spacing(2),
  height: '100%',
  justifyContent:'start',
  textAlign: 'start',
  textTransform: 'none',
  color: 'white',
  position: 'relative',
  overflow: 'hidden',
  transition: 'all 0.3s ease',
  '&:hover': {
    background: `linear-gradient(15deg, ${gradientfrom} 0%, ${gradientto} 100%)`,
    boxShadow: theme.shadows[4],
    transform: 'scale(1.02)',
  },
}));

const IconWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: alpha(theme.palette.common.white, 0.2),
  borderRadius: theme.spacing(1),
  width: 40,
  height: 40,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: theme.spacing(2),
}));

const SupportButton = styled(Button)(({ theme }) => ({
  width: '100%',
  justifyContent: 'flex-start',
  padding: theme.spacing(2),
  marginBlock:theme.spacing(1),
  backgroundColor: theme.palette.grey[50],
  borderRadius: theme.spacing(1),
  border: `1px solid ${theme.palette.grey[200]}`,
  textTransform: 'none',
  color: theme.palette.text.primary,
  '&:hover': {
    backgroundColor: theme.palette.grey[100],
  },
}));


const Dashboard = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { search } = useLocation();
  const obj = new URLSearchParams(search);
  const { Authorized, allModules } = useSelector((state) => ({
    ...state.Dashboard,
  }));
    const modules = useSelector(state => state.ReducerUserData.modules)
  useLayoutEffect(() => {
    dispatch(getModules());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    const lang = obj.get("lang");
    if (lang === "en" || lang === "fr") {
      i18next.changeLanguage(lang);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [obj.get("lang")]);

const redirect= (path) => {
  window.parent.postMessage({ info: "path", value: path }, "*");
}
const [videosViews, setVideosViews] = useState(0)
const [usersNB, setusersNB] = useState(0)
const [recentLives, setRecentLives] = useState(0)
const [, setRecentVideos] = useState(0)
const [recentContent, setRecentContent] = useState(0)
const [, setUserId] = useState(null)
const [, setChannel] = useState("")
const [videoAuthorized, setVideoAuth] = useState(false)
const [podcastAuthorized, setPodcastAuth] = useState(false)
const [liveAuthorized, setLiveAuth] = useState(false)
const userData = useSelector((state) => state.ReducerUserData.userData);
 const statsInfo = [
  {
    gradientfrom:"#dbeafe",
    gradientto:"#eff6ff",
    bordercolor:"#bfdbfe",
    Icon:VideocamOutlinedIcon,
    styleIcon:{ color: '#1d4ed8' },        // blue
    title:t("Dashboard.videosView"),
    styleTitle:{ fontWeight: 'bold', color: '#1e3a8a' },  // dark blue
    value:videosViews,
    permission:true
  },
  {
    gradientfrom:"#f3e8ff",
    gradientto:"#faf5ff",
    bordercolor:"#e9d5ff",
    Icon:PeopleOutlinedIcon,
    styleIcon: { color: '#9333ea' },       // purple
    title: t("Dashboard.Internautes"),
    styleTitle:{ fontWeight: 'bold', color: '#6b21a8' },  // dark purple
    value:usersNB,
    permission:modules?.profiles_user_list_dtable || +userData?.id === 1
  },
  {
    gradientfrom:"#d1fae5",
    gradientto:"#ecfdf5",
    bordercolor:"#a7f3d0",
    Icon:StickyNote2OutlinedIcon,
    styleIcon: { color: '#059669' },       // green
    title: t("Dashboard.recent_content"),
    styleTitle:{ fontWeight: 'bold', color: '#065f46' },  // dark green
    value:recentContent,
    permission:true
  },
  {
    gradientfrom:"#ffedd5",
    gradientto:"#fff7ed",
    bordercolor:"#fed7aa",
    Icon:SensorsOutlinedIcon,
    styleIcon: { color: '#d97706' },       // orange
    title:t("Dashboard.recent_lives"),
    styleTitle: { fontWeight: 'bold', color: '#92400e' }, // dark orange
    value:recentLives,
    permission: liveAuthorized
  }
]
  const quickAccessList =[
    {
      'gradientfrom': '#5d98f7ff',
      'gradientto': '#4c71d6ff',
      'Icon': VideocamOutlinedIcon,
      'title' : t("Dashboard.videos") ,
      redirectPath:'videos',
      'description' :  t("Dashboard.Manage_Your_Video_Content"),
      'permission' : videoAuthorized
    },
    {
      'gradientfrom': '#9a73f5ff',
      'gradientto': '#8a52ecff',
      'Icon': SensorsOutlinedIcon,
      'title' : t("Dashboard.Directs"),
       redirectPath:'directs',
      'description' :  t("Dashboard.Start_a_LiveStream"),
       permission: liveAuthorized
    },
    {
      'gradientfrom': '#10b981',
      'gradientto': '#059669',
      'Icon': PodcastsOutlinedIcon,
       redirectPath:'Podcasts',
      'title' : t("Dashboard.Podcasts"),
      'description' :  t("Dashboard.Your_Audio_Content"),
       permission: podcastAuthorized
     },
    {
      'gradientfrom': '#f7b23cff',
      'gradientto': '#db8a2eff',
      'Icon': BarChartOutlinedIcon,
       redirectPath:'Statistiques',
      'title' : t("Dashboard.Statistiques"),
      'description' :  t("Dashboard.Detailed_Analytics"),
       permission : true
     }


  ]
  const SupportLinks =[
   
   {
     blocktitle : 'Support',
     items:[
      {
        Icon : IntegrationInstructionsOutlinedIcon,
        subtitle : 'Release Note',
        link:'https://release.empreinte.com/',
        description: t('Dashboard.note_version')
      },

    ]
   },
   {
    blocktitle: 'Guide',
    items:[
      {
        Icon: StickyNote2OutlinedIcon,
        subtitle : t('Dashboard.User_Guide'),
        link:'https://docs.empreinte.com/' ,
        description: t("Dashboard.guide_desc")
      }
    ]
   
   },
  ]
  const getDateRange = () => {
  const today = new Date();
  const lastMonth = subMonths(today, 1);
  const startDate = format(lastMonth, 'yyyy-MM-dd');
  const endDate = format(today, 'yyyy-MM-dd');
  return { startDate, endDate };
};
const { startDate, endDate } = getDateRange();

    
  useEffect(() => {
  const fetchAllStats = async () => {
    try {
      // Video stats
    let podcastAuth = modules?.podcast_list_dtable;
    let videoAuth = modules?.media_video_list_dtable_videos_ongoing;
    let liveAuth = modules?.lives_dtable_lives_endless;
    setChannel(userData?.channels?.[0] ?? "")
    setVideoAuth(videoAuth);
    setPodcastAuth(podcastAuth);
    setLiveAuth(liveAuth)
     let Body = {
    empStatsQuery: {
    "lunchFilter": true,
    "range": "1d",
    "group": "",
    "dateIn": startDate,
    "dateOut": endDate,
    "startDate": "",
    "endDate": "",
    "theme": "",
    "vod_id": "",
    "canal": userData?.id !== 1 && userData?.channels?.length
  ? String(userData.channels[0])
  : "",
    "host_api":window.process.env.API_HOST_GLOBAL,
    "type": "internet,internet_mobile,intranet,intranet_mobile"
}
  };
      const videoStatData = await PostData('/stat/mesure/visite/videos-vue', Body);
      const usersData = await GetData('/video-api/user/?columns[0][orderable]=true&length=1&idGroup=0&order[0][column]=0&order[0][dir]=asc&search[value]=&start=0');
      setUserId(usersData?.data?.data?.data?.[0]?.id)
      setusersNB(usersData?.data?.data?.recordsTotal ?? 0);
      setVideosViews(videoStatData?.data?.values?.visite?.videos_vue?.value ?? 0);
      // Functions for recent items (return counts)
      const livesRecent = async () => {
        try {  
    const allDirects = await GetData(`/live/all?draw=1&length=10&start=0&order[0][dir]=desc&order[0][column]=0&columns[0][orderable]=true&idContributor=&&startDate&period=month&searchWord=&idUser=${userData?.id}`);
    return allDirects?.data?.recordsFiltered ?? 0;
  } catch (err) {
    console.error("Lives error", err);
    return 0;
  }
      };

      const VideosRecent = async () => {
        try {
    const allVideos = await GetData(`/video-api/video/all?columns\\[0\\]\\[orderable\\]=true&draw=1&length=20&order\\[0\\]\\[column\\]=0&order\\[0\\]\\[dir\\]=desc&start=0&period=month`);
    return allVideos?.data?.recordsFiltered ?? 0;
  } catch (err) {
    console.error("Videos error", err);
    return 0;
  }
      };

      const getLatestPodcast = async () => {
         try {
    const allPodcasts = await GetData(`/dataTable/podcast?columns%5B0%5D%5Borderable%5D=true&draw=1&length=5&order%5B0%5D%5Bcolumn%5D=0&order%5B0%5D%5Bdir%5D=desc&start=0`);
    const dateOfPreviousMonth = subMonths(new Date(), 1);
    const parseCustomISO = str =>
      parseISO(str.replace(/([+-]\d{2})(\d{2})$/, "$1:$2"));
    return (
      allPodcasts?.data?.data?.filter(
        ({ created_at }) => parseCustomISO(created_at) > dateOfPreviousMonth
      ).length ?? 0
    );
  } catch (err) {
    console.error("Podcast error", err);
    return 0;
  }
      };  

      const [recentLivesCount, recentVideosCount, recentPodcastsCount] = await Promise.all([
        liveAuth ? livesRecent() : 0,
        videoAuth ? VideosRecent() : 0,
        podcastAuth ? getLatestPodcast() : 0
      ]);
      // Set states
      setRecentLives(recentLivesCount);
      setRecentVideos(recentVideosCount);
      setRecentContent(recentLivesCount + recentVideosCount + recentPodcastsCount);

    } catch (err) {
      console.error("Error fetching stats:", err);
    }
  };
  if(Authorized)
  fetchAllStats();
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [Authorized,allModules]);
const navigateToLink = (link) => {
   window.open(link, "_blank");
}
    useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://widget.webtv-solution.video/embed-popup.js";
    script.dataset.lkSandboxId = "https://widget";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box 
     className="dashboard-container"
      sx={{ 
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
        py: 4
      }}
    >
      
      <Container maxWidth="xxl">
        <Box sx={{ mb: 4 }}>
          <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold', color: 'text.primary', mb: 1 }}>
            Dashboard
          </Typography>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            {t('Dashboard.activity_overview')}
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          <Paper 
            elevation={0}
            sx={{ 
              backgroundColor: 'white',
              borderRadius: 3,
              border: '1px solid',
              borderColor: 'grey.200',
              p: 3
            }}
          >
            <Typography 
              variant="h5" 
              component="h2" 
              sx={{ 
                fontWeight: 'semibold', 
                color: 'text.primary', 
                mb: 2,
                display: 'flex',
                alignItems: 'center',
                gap: 1
              }}
            >
              <BarChartOutlinedIcon sx={{ color: 'primary.main' }} />
              {t('Dashboard.Monthly_Activity')}
            </Typography>
         <Grid className="stats-dashboard" container spacing={2}>
            {statsInfo?.map(({gradientfrom, gradientto, bordercolor, Icon, title, value, styleIcon, styleTitle, permission}, index) => {
  return permission && (
    <Grid key={index} item xs={12} sm={6} md={3}>
      <GradientCard gradientfrom={gradientfrom} gradientto={gradientto} bordercolor={bordercolor}>
        <CardContent>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
            <Icon style={styleIcon} />
            <Typography variant="body2" style={{ fontWeight: 500, color: '#64748b' }}>
              {title}
            </Typography>
          </Box>
          <Typography variant="h4" component="p" style={styleTitle}>
            {value}
          </Typography>
        </CardContent>
      </GradientCard>
    </Grid>
  )
})}
</Grid>
      
      
    
      
      
      
          </Paper>

          {/* Quick Access */}
          <Paper 
            elevation={0}
            sx={{ 
              backgroundColor: 'white',
              borderRadius: 3,
              border: '1px solid',
              borderColor: 'grey.200',
              p: 3
            }}
          >
            <Typography variant="h5" component="h2" sx={{ fontWeight: 'semibold', color: 'text.primary', mb: 3 }}>
              {t('Dashboard.Quick_Access')}
            </Typography>
            <Grid container spacing={2}>
     
              
           {quickAccessList?.map(({gradientfrom,gradientto,Icon,title,description,redirectPath, permission},index)=>{
            return permission && <Grid key={index} item xs={12} sm={6} md={3}  onClick={()=> { redirect(redirectPath)}} >
                <QuickAccessButton
                  fullWidth
                  gradientfrom={gradientfrom}
                  gradientto={gradientto}
                >
                  <Box sx={{ position: 'relative', zIndex: 10 }}>
                    <IconWrapper >
                      <Icon sx={{ color: 'white',display: 'inline-flex' }} />
                    </IconWrapper>
                    <Typography variant="h6" component="h3" sx={{ fontWeight: 'semibold', color: 'white', mb: 1 }}>
                      {title}
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'success.100' }}>
                      {description}
                    </Typography>
                  </Box>
                </QuickAccessButton>
              </Grid>
            })}

            </Grid>
          </Paper>

          {/* Support & Guide */}
          <Grid container spacing={3}>

           {SupportLinks.map(({blocktitle,items}, index)=>
           { 
           return  <Grid key={index} item xs={12} md={6}>
              <Paper 
                elevation={0}
                sx={{ 
                  backgroundColor: 'white',
                  borderRadius: 3,
                  border: '1px solid',
                  borderColor: 'grey.200',
                  p: 3,
                  height:'100%'
                }}
              >
                <Typography 
                  variant="h5" 
                  component="h2" 
                  sx={{ 
                    fontWeight: 'semibold', 
                    color: 'text.primary', 
                    mb: 2,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1
                  }}
                >
                  <HelpOutlineOutlinedIcon sx={{ color: 'text.secondary' }} />
                  {blocktitle}
                </Typography>
             {items.map(({Icon, subtitle, description,link},index) =>  <SupportButton disabled={link === "#"} key={index} onClick={()=>navigateToLink(link)}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 4}}>
                    <Box sx={{ backgroundColor: 'primary.100', borderRadius: 1, p: 1 }}>
                      <Icon sx={{ color: 'primary.main' }} />
                    </Box>
                    <Box sx={{ flex: 1, justifyContent:'flex-start',alignItems:'flex-start' }}>
                      <Typography variant="body1" sx={{display:'flex',alignSelf:'start',color: 'text.primary', fontWeight: 'medium' }}>
                        {subtitle}
                      </Typography>
                      <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                        {description}
                      </Typography>
                    </Box>
                  </Box>
                </SupportButton>)}
              </Paper>
            </Grid>
            })
            }
          </Grid>
          <div style={{display:'flex',justifyContent:'flex-end',alignItems:'flex-end'}}>
           <div id="chatbot-container" />
          </div>
        </Box>
      </Container>
    </Box>
  );
};

export default Dashboard;